class studentsServices {
    constructor($resource,SERVICE_URL_CONSTANT) {
		const services = $resource(SERVICE_URL_CONSTANT.adminPanel +'/students/:route',{},{
			getStudents:{
				method:'GET',
				params : {}
			},
			getEnabledEvaluations:{
				method:'GET',
				params : {
					route : 'enabled-student'
				}
			},
			getStudentByEducator:{
				method:'GET',
				params : {
					route : 'level-educator-period'
				}
			},
			getStudentDetails:{
				method:'GET',
				params : {
					route: 'id'
				}
			},
			saveStudents:{
				method:'POST',
				params : {}
			},
			updateStudents:{
				method:'PUT',
				params : {}
			},
		});

		return {
			services : services
		};
	}
}

studentsServices.$inject=['$resource','SERVICE_URL_CONSTANT']

export default  angular.module('services.studentsServices', [])
.service('studentsServices', studentsServices)
.name;



// WEBPACK FOOTER //
// ./src/app/admin-panel/students/studentsServices.js